import React, { Component } from 'react'
import Slider from 'react-slick'
import Truncate from 'react-truncate'
import { Link } from 'react-router-dom'
import { Header, Columns } from '../../../../components/elements'
import { apiProcess } from '../../../../components/api/api'
import { navBarOffSet } from '../../../../components/search/layout/searchUtil'
import { eventsMaxDistanceDefault } from '../../../../components/search/filters/moreFiltersContainer/distanceFilterConfig'
import { formatShortenedEventDate } from '../../../../components/utils'
import './bikeprofileMotorcycleEvents.css'

const getEventLogo = (type) => {
  if (type === 'Bike Night') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/bikeNight.png'
  } else if (type === 'Swap Meet') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/swap.png'
  } else if (type === 'Motorcycle Show') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/show.png'
  } else if (type === 'Benefit - Charity') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/charity.png'
  } else if (type === 'Party') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/party.png'
  } else if (type === 'Poker Run') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/poker.png'
  } else if (type === 'Motorcycle Race') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/race.png'
  } else if (type === 'Motorcycle Rally') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/rally.png'
  } else if (type === 'General Ride') {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/general.png'
  } else {
    return 'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567719801/frontend_assets/events/other.png'
  }
}

const BikeEvents = ({
  event,
  singleEvent,
  latitude,
  longitude,
  location,
  isMobile,
}) => {
  return (
    <Link
      to={`/events/${event.pretty_id}/${event.event_name.toLowerCase().split(" ").join("-")}`}
      target="_blank"
    >
      <Columns>
        <Columns.Column size={singleEvent ? 3 : 'auto'}>
          <div className="event-image">
            <img
              src={getEventLogo(event.event_type)}
              alt="events-card"
              className="event-card-type-icon"
            />
          </div>
        </Columns.Column>
        <Columns.Column size={6} style={{ marginRight: '20px' }}>
          <p className="events-dates mt-2">
            {formatShortenedEventDate(event.start_date, event.end_date, event.location.timezone)}
          </p>
          <h1 className="bike-profile-subHeading">
            {event.event_name}
            <br />
          </h1>
          <div className="events-location">
            <h2 className="mt-2">
              {event.location.city}, {event.location.region_abbreviation}
            </h2>
            <p>{event.event_type}</p>
          </div>
          <div className="has-text-dark">
            <Truncate lines={isMobile ? 2 : 3} ellipsis={'...'}>
              {event.event_description}
            </Truncate>
          </div>
        </Columns.Column>
      </Columns>
    </Link>
  )
}

const BackArrow = (props) => {
  const settings = {
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    background: props.isMobile
      ? 'none'
      : 'linear-gradient(180deg, #AF985F 0%, #695626 100%)',
    boxShadow: props.isMobile ? 'none' : '0px 0px 8px rgba(0, 0, 0, 0.32)',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick, className, style } = props
  return (
    <div className="events-prev-btn-container">
      <div className="events-prevarrow-wrapper" onClick={onClick}>
        <div classname="prev-arrow">
          <i className="fas fa-angle-left" style={settings}></i>
        </div>
      </div>
    </div>
  )
}

const NextArrow = (props) => {
  const settings = {
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    background: props.isMobile
      ? 'none'
      : 'linear-gradient(180deg, #AF985F 0%, #695626 100%)',
    boxShadow: props.isMobile ? 'none' : '0px 0px 8px rgba(0, 0, 0, 0.32)',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
  const { onClick, className, style } = props
  return (
    <div className="events-next-btn-container">
      <div className="events-nextarrow-wrapper" onClick={onClick}>
        <div classname="next-arrow">
          <i className="fas fa-angle-right" style={settings}></i>
        </div>
      </div>
    </div>
  )
}

export const getSliderSettings = (arraySize, isMobile) => {
  return {
    dots: false,
    infinite: arraySize !== 1,
    speed: 500,
    slidesToShow: arraySize === 1 ? 1 : 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: arraySize === 1 ? 1 : 2,
          slidesToScroll: 1,
          infinite: arraySize !== 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
    prevArrow: <BackArrow isMobile={isMobile} />,
    nextArrow: <NextArrow isMobile={isMobile} />,
  }
}

class BikeProfileMotorcycleEvents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      eventsSearchData: props.bikeData?.nearby_events,
    }
  }
  calcMinHeight = (offset) => {
    return window.innerHeight - offset
  }

  render() {
    const { isMobile, bikeData, isAuth } = this.props
    const { eventsSearchData } = this.state
    const navbarOffset = navBarOffSet(isMobile)
    const layoutStartOffset = navbarOffset.layoutStart

    return (
      <>
        {eventsSearchData?.length > 0 && (
          <div>
            <div className="things-to-do">
              <Header
                renderas="h2"
                size={5}
                className="has-text-weight-bold mb-4 ttd-header"
              >
                Things to Do
              </Header>
              <div className='is-flex is-align-items-center'>
                <h3 className="bike-profile-subHeading mb-5">Events Nearby</h3>
                <i class="fa-solid fa-calendar ml-2 mb-5"></i>
              </div>
            </div>
            <div
              style={{
                width: isMobile ? '100%' : '145%',
              }}
            >
              <Slider {...getSliderSettings(eventsSearchData.length, isMobile)}>
                {eventsSearchData.map((motorcycleEvent, index) => {
                  return (
                    <BikeEvents
                      key={index}
                      event={motorcycleEvent}
                      singleEvent={eventsSearchData.length === 1}
                      latitude={bikeData.bike_location.search_latitude}
                      longitude={bikeData.bike_location.search_longitude}
                      location={bikeData.bike_location.location_city}
                      isMobile={isMobile}
                    />
                  )
                })}
              </Slider>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default BikeProfileMotorcycleEvents
